import styled, { keyframes, css } from 'styled-components';
import { Grid, colors, mixins, media } from '@custom-components';

const openSearch = css`
  ${keyframes`
  0%{
    max-height: 0;
    padding: 0;
  
  }
  100% {
    max-height: ${mixins.pxToRem(300)};
    padding: ${mixins.pxToRem(15)} 0;
  }
  `}
`;

const closeSearch = css`
  ${keyframes`
  0%{
    max-height: ${mixins.pxToRem(300)};
    padding: ${mixins.pxToRem(15)} 0;
  
  }
  100% {
    max-height: 0;
    padding: 0;
  }
  `}
`;

const openSearchSmall = css`
  ${keyframes`
  0%{
    max-height: 0;
    padding: 0;
  
  }
  100% {
    max-height: ${mixins.pxToRem(560)};
    padding: ${mixins.pxToRem(15)} 0;
  }
  `}
`;

const closeSearchSmall = css`
  ${keyframes`
  0%{
    max-height: ${mixins.pxToRem(560)};
    padding: ${mixins.pxToRem(15)} 0;
  
  }
  100% {
    max-height: 0;
    padding: 0;
  }
  `}
`;

export const ColWithBottomMargin = styled(Grid.Col)`
  margin-bottom: 10px;

  .bookingSearchWidgetCon & {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
  .propertySearchWidgetCon & {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
`;

export const ButtonCol = styled(ColWithBottomMargin)`
  margin-left: auto !important;
  padding: 0 14px !important;

  .bookingSearchWidgetCon & {
    flex: 0 0 80% !important;
    max-width: 80% !important;
  }

  .propertySearchWidgetCon & {
    flex: 0 0 80% !important;
    max-width: 80% !important;
  }
`;

export const AdvancedSearchContainer = styled.div`
  position: absolute;
  overflow: hidden;
  width: 100%;
  background-color: ${colors.colorWhite};
  z-index: 10;

  max-height: 0;
  padding: 0;

  &.opensearch-enter {
    max-height: 0;
    padding: ${mixins.pxToRem(15)} 0;
    border-bottom: 1px solid;
    border-color: ${colors.colorGrey04};
  }
  &.opensearch-enter-active {
    animation: ${openSearch} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  &.opensearch-enter-done {
    max-height: ${mixins.pxToRem(1000)};
    padding: ${mixins.pxToRem(15)} 0;
    overflow: visible;
    border-bottom: 1px solid;
    border-color: ${colors.colorGrey04};
  }
  &.opensearch-exit {
    overflow: hidden;
    max-height: ${mixins.pxToRem(300)};
    padding: ${mixins.pxToRem(15)} 0;
  }
  &.opensearch-exit-active {
    animation: ${closeSearch} 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  &.opensearch-exit-done {
    max-height: 0;
    padding: 0;
    overflow: hidden;
  }

  ${media.lessThan('md')`

  &.opensearch-enter {
    max-height: 0;
  }
  &.opensearch-enter-active {
    animation: ${openSearchSmall} 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  &.opensearch-enter-done {
    max-height: ${mixins.pxToRem(1000)};
    padding: ${mixins.pxToRem(15)} 0;
  }
  &.opensearch-exit {
    max-height: ${mixins.pxToRem(560)};
    padding: ${mixins.pxToRem(15)} 0;
  }
  &.opensearch-exit-active {
    animation: ${closeSearchSmall} 0.6s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  &.opensearch-exit-done {
    max-height: 0;
    padding: 0;
  }

`};

  .bookingSearchWidgetCon & {
    max-height: ${mixins.pxToRem(1000)};
    padding: 0;
    overflow: visible;
    border-bottom: 1px solid;
    border-color: ${colors.colorGrey04};
    position: relative;
  }

  .propertySearchWidgetCon & {
    max-height: ${mixins.pxToRem(1000)};
    padding: 0;
    overflow: visible;
    border-bottom: 1px solid;
    border-color: ${colors.colorGrey04};
    position: relative;
    z-index: auto;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  bottom: 0;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const FilterButton = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  ${media.lessThan('md')`margin-bottom: ${mixins.pxToRem(16)};`};
`;

export const ChipBar = styled.div`
  width: 100%;
  background-color: ${colors.colorGrey04};
  padding: 0 19px;
`;

export const GridContainer = styled(Grid.Container)`
  padding: 0px 24px !important;
`;
